import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetServiceCompanyList } from "../../Responses/ServiceCompany/GetServiceCompanyList";

export async function getServiceCompanyListService(data) {
    let response = await getAPIResponse("/v1/service-company-list", data);
    if (response === null) {
        return null;
    }
    let getServiceCompanyList = GetServiceCompanyList.createFromResponseData(response);
    return getServiceCompanyList;
}